import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { ServiceInstance } from "app/models/service-instance";
import { ServiceService } from "app/services/service.service";

@Injectable()
export class ServiceInstanceResolver implements Resolve<ServiceInstance> {

  constructor(
    private serviceService: ServiceService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ServiceInstance> {
    // Get the 'ID' Path parameter which is the ID of the Service to obtain...
    const id = route.paramMap.get('id');
    console.log(`Obtaining Service for ID: '${id}'...`);
    
    if (id == null || id.length == 0) {
      return null;
    }

    return await this.serviceService.getServiceInstanceById(id);
  }

}